import { PoItems } from "../po-creation-items.entity";
import { PoCreation } from "../po-creation.entity";
import { PoDetailsDTO } from "./po-details-create.dto";

export class POAdapter {
    public convertDtoToEntity(purchaseOrderDTO: PoDetailsDTO, currentFinancialYear: string): PoCreation {
        const purchaseOrder = new PoCreation();
        purchaseOrder.saleOrderId = purchaseOrderDTO.saleOrderId;
        purchaseOrder.purchaseOrderDate = purchaseOrderDTO.purchaseOrderDate;
        purchaseOrder.vendorName = purchaseOrderDTO.vendorId;
        purchaseOrder.paymentTerms = purchaseOrderDTO.paymentTerms;
        purchaseOrder.shippingTerms = purchaseOrderDTO.shippingTerms;
        purchaseOrder.deliveryTerms = purchaseOrderDTO.deliveryTerms;
        purchaseOrder.paymentTerms = purchaseOrderDTO.paymentTerms;
        purchaseOrder.expectedDeliveryDate = purchaseOrderDTO.expectedDeliveryDate;
        purchaseOrder.note = purchaseOrderDTO.note;
        purchaseOrder.remarks = purchaseOrderDTO.remarks;
        purchaseOrder.deliveryAddress = purchaseOrderDTO.deliveryAddress;
        purchaseOrder.plantAddress = purchaseOrderDTO.plantAddress;
        purchaseOrder.billingAddress = purchaseOrderDTO.billingAddress;
        purchaseOrder.exchangeRate = purchaseOrderDTO.exchangeRate;
        purchaseOrder.totalTransportation = purchaseOrderDTO.transportation;
        purchaseOrder.poType = purchaseOrderDTO.poType;
        purchaseOrder.unitId = purchaseOrderDTO.unitId;

        if (purchaseOrderDTO.purchaseOrderId) {
            purchaseOrder.updatedUser = purchaseOrderDTO.updatedUser;
            purchaseOrder.purchaseOrderId = purchaseOrderDTO.purchaseOrderId;
        } else {
            purchaseOrder.createdUser = purchaseOrderDTO.createdUser;
            purchaseOrder.poNumber = currentFinancialYear;
        }
        const poItems: PoItems[] = [];

        for (const poItemsDto of purchaseOrderDTO.poItems) {
            const poItem = new PoItems();
            poItem.itemCategory = poItemsDto.itemCategory;
            poItem.itemSubCategoryId = poItemsDto.itemSubCategoryId;
            poItem.itemName = poItemsDto.item;
            poItem.size = poItemsDto.size;
            poItem.itemQuantity = poItemsDto.quantity;
            poItem.itemCost = poItemsDto.unitPrice;
            poItem.discountPer = poItemsDto.discountPercentage;
            poItem.discount = poItemsDto.discountAmount;
            poItem.taxPer = poItemsDto.tax;
            poItem.tax = poItemsDto.taxAmount;
            poItem.transportation = poItemsDto.transportation;
            poItem.subAmount = poItemsDto.Amount;
            poItem.purchaseOrderId = purchaseOrderDTO.purchaseOrderId;
            poItem.bomItemId = poItemsDto.bomItemId;
            poItem.saleOrderId = poItemsDto.saleOrderId;
            poItem.fromPo =(poItemsDto?.bomItemId)?false:true;
            poItem.isActive = poItemsDto.isActive;
            if (poItemsDto.purchaseOrderItemId) {
                poItem.purchaseOrderItemId = poItemsDto.purchaseOrderItemId;
                poItem.updatedUser = poItemsDto.updatedUser;
            } else {
                poItem.createdUser = poItemsDto.createdUser;
            }
            poItems.push(poItem);
        }
        purchaseOrder.poCreationItemsInfo = poItems;
        return purchaseOrder;
    }
}